import { useState } from 'react';

//services
import { wpAjax } from '../services/api';

const useProjects = () => {
  const [projects, setProjects] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [isFetchingProjects, setIsFetchingProjects] = useState(false);

  // Fetch all projects
  const fetchProjects = async () => {
    setIsFetchingProjects(true);
    try {
      const data = await wpAjax('fl_fetch_projects');
      setProjects(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to fetch projects:', error.message);
      setProjects([]);
    } finally {
      setIsFetchingProjects(false);
    }
  };

  // Update a single project
  const updateProject = async (projectData) => {
    try {
      await wpAjax('fl_update_project', projectData);
      fetchProjects();
    } catch (error) {
      console.error('Failed to update project:', error.message);
    }
  };

  // Delete a single project (with visual feedback)
  const deleteProject = async (projectID) => {
    setProjects((prev) =>
      prev.map((project) =>
        project.ID === projectID ? { ...project, isDeleting: true } : project
      )
    );

    try {
      await wpAjax('fl_delete_project', { post_id: projectID });
      fetchProjects();
    } catch (error) {
      console.error('Failed to delete project:', error.message);
    }
  };

  // Delete multiple projects (with visual feedback)
  const deleteProjects = async (projectIDs) => {
    setProjects((prev) =>
      prev.map((project) =>
        projectIDs.includes(project.ID)
          ? { ...project, isDeleting: true }
          : project
      )
    );

    try {
      await wpAjax('fl_delete_projects', {
        post_ids: JSON.stringify(projectIDs)
      });
      fetchProjects();
    } catch (error) {
      console.error('Failed to delete projects:', error.message);
    }
  };

  return {
    projects,
    // setProjects,
    projectLoading,
    setProjectLoading,
    fetchProjects,
    isFetchingProjects,
    updateProject,
    deleteProject,
    deleteProjects
  };
};

export default useProjects;
